import { render, staticRenderFns } from "./PurchaseOrderView.vue?vue&type=template&id=1768f526"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1768f526')) {
      api.createRecord('1768f526', component.options)
    } else {
      api.reload('1768f526', component.options)
    }
    module.hot.accept("./PurchaseOrderView.vue?vue&type=template&id=1768f526", function () {
      api.rerender('1768f526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderView.vue"
export default component.exports